import { createStyles, makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(() => {
  return createStyles({
    container: {
      '& img': {
        marginTop: 5,
        width: 35,
      },
    },
  });
});

export default styles;
